import React from 'react'
import { links } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Logo from 'components/ui/Logo/Logo'
import Link from 'components/ui/Link/Link'

import Box from 'components/_new/layout/Box/Box'
import AppStoreButton from 'components/ui/AppStoreButton/AppStoreButton'
import commonMessages from 'components/layout/Footer/FooterView/messages'

import messages from './messages'
import s from './FooterMain.scss'


const makeupUrls = ['/makeup-intro', '/sweatcoin-makeup', '/makeup-landing']

// TODO make separate footer for landings and site

const FooterMain = ({ logoLink, isLandings }) => {
  const isLinkToLanding  = !logoLink || logoLink === links.home
  const discoverText     = makeupUrls.includes(logoLink) ? messages.discoverNewMakeup : messages.discoverNewFragrance

  const logoProps = isLinkToLanding ? {
    redirect: links.home,
  } : {
    to: logoLink,
  }

  const inviteLinkProps = isLandings ? {
    toOLD: links.invite,
  } : {
    to: links.invite,
  }

  const requestLinkProps = isLandings ? {
    toOLD: links.request,
  } : {
    to: links.request,
  }

  return (
    <div>
      <Logo className={s.logo} light {...logoProps} />
      <FormattedHTMLMessage className={s.discover} {...discoverText} values={{ price: 14.95 }} />
      <Link className={s.brandLink} customColor title={commonMessages.inviteAndEarn} {...inviteLinkProps} />
      <Link className={s.brandLink} customColor title={commonMessages.requestFragrance} {...requestLinkProps} />
      <Box mt="16">
        <AppStoreButton isLandings={isLandings} />
      </Box>
    </div>
  )
}


export default FooterMain
